import { getCurrentIntlLocale } from "#/lib/formatters";
import type { TimeRange } from "../hooks/use-portfolio-chart";

export const EDGE_THRESHOLD = 0.08;

export function formatAxisDate(ts: number, range: TimeRange) {
	const locale = getCurrentIntlLocale();
	const d = new Date(ts);
	if (range === "24H") {
		return new Intl.DateTimeFormat(locale, {
			hour: "2-digit",
			minute: "2-digit",
			hour12: false,
		}).format(d);
	}
	if (range === "All") {
		return new Intl.DateTimeFormat(locale, {
			month: "short",
			year: "2-digit",
		}).format(d);
	}
	return new Intl.DateTimeFormat(locale, {
		month: "numeric",
		day: "numeric",
	}).format(d);
}

export function formatTooltipDate(ts: number) {
	return new Intl.DateTimeFormat(getCurrentIntlLocale(), {
		month: "short",
		day: "numeric",
		hour: "2-digit",
		minute: "2-digit",
		hour12: false,
	}).format(new Date(ts));
}
